import { environment } from '../../../../environments/environment';

export const consultant = [
  {
    id: environment.stripePrices.consultantBasic,
    name: 'Basic',
    price: '€97',
    duration: 'month',
    type: 'subscription',
    licenses: 5,
    logoIncluded: false,
    reportsIncluded: false,
    videosIncluded: false,
    details: [
      '5 Licenses',
      'Reports upon request: €250 each + VAT',
      'Customization with your logo: €50 each + VAT',
    ],
  },
  {
    id: environment.stripePrices.consultantPro,
    name: 'Pro',
    price: '€497',
    duration: 'month',
    type: 'subscription',
    licenses: 30,
    logoIncluded: false,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      '30 Licenses',
      'Reports included',
      'Customization with your logo: €50 each + VAT + Carbon Manager included',
    ],
  },
  {
    id: environment.stripePrices.consultantMaster,
    name: 'Master',
    price: '€997',
    duration: 'month',
    type: 'subscription',
    licenses: 100,
    logoIncluded: true,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      '100 Licenses',
      'Reports included',
      'Customization with your logo + Carbon Manager included',
    ],
  },
];

export const consultantIT = [
  {
    id: environment.stripePrices.consultantBasic,
    name: 'Basic',
    price: '€97',
    duration: 'mese',
    type: 'subscription',
    licenses: 5,
    logoIncluded: false,
    reportsIncluded: false,
    videosIncluded: false,
    details: [
      '5 Licenze',
      'Report su richiesta: €250 ciascuno + IVA',
      'Personalizzazione con il tuo logo: €50 ciascuno + IVA',
    ],
  },
  {
    id: environment.stripePrices.consultantPro,
    name: 'Pro',
    price: '€497',
    duration: 'mese',
    type: 'subscription',
    licenses: 30,
    logoIncluded: false,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      '30 Licenze',
      'Report inclusi',
      'Personalizzazione con il tuo logo: €50 ciascuno + IVA + Carbon Manager incluso',
    ],
  },
  {
    id: environment.stripePrices.consultantMaster,
    name: 'Master',
    price: '€997',
    duration: 'mese',
    type: 'subscription',
    licenses: 100,
    logoIncluded: true,
    reportsIncluded: true,
    videosIncluded: true,
    details: [
      '100 Licenze',
      'Report inclusi',
      'Personalizzazione con il tuo logo + Carbon Manager incluso',
    ],
  },
];
